import { render, staticRenderFns } from "./ResetPasswordNotification.vue?vue&type=template&id=4ec287da&"
import script from "./ResetPasswordNotification.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports